import _ from "lodash";
import React from "react";
import {
  ArchiveOutlined,
  DeleteOutlined,
  PencilLineOutlined,
} from "@toddle-edu/ds-icons";

const getUserTypeFeedLabels = ({
  canManageEvaluationCycles,
  isVisitor,
  index,
  t,
}) => {
  const ongoingCyclesLabel = t("snp:ongoing_cycles");
  const archivedCyclesLabel = t("common:previous_with_label", {
    label: t("common:lowercase", {
      text: t("snp:cycle_plural"),
    }),
  });
  const authAndEvalLabel = t("snp:authorization_evaluation");

  if (canManageEvaluationCycles)
    return [ongoingCyclesLabel, archivedCyclesLabel][index];

  if (isVisitor) return authAndEvalLabel;

  return ongoingCyclesLabel;
};

export const getGroupedCycles = ({
  cycles,
  canManageEvaluationCycles,
  isVisitor,
  feedType,
  t,
  snpModuleLabelSetting,
}) => {
  if (feedType === "VIEW_AND_EDIT") {
    /** In Admin View, Cycles feed is split into Ongoing cycles and Archived cycles */
    const groupedCycles = canManageEvaluationCycles
      ? _.partition(cycles, ["isArchived", false])
      : [cycles];

    return _.map(groupedCycles, (cycleGroup, index) => {
      return {
        headerLabel: getUserTypeFeedLabels({
          canManageEvaluationCycles,
          isVisitor,
          index,
          t,
        }),
        data: cycleGroup,
      };
    });
  } else {
    return [
      {
        headerLabel: t(`snp:${snpModuleLabelSetting}`, {
          defaultValue: snpModuleLabelSetting,
        }),
        data: cycles,
      },
    ];
  }
};

const getCycleCardDropdownOptions = ({ isTitleEmpty, isArchived, t }) => {
  const allOptions = [
    {
      label: t("common:edit_with_label", { label: t("common:title") }),
      key: "EDIT",
      isVisible: !isTitleEmpty /** do not show edit title option for old snp cycle with no title */,
      icon: <PencilLineOutlined />,
    },
    {
      label: t("common:unarchive"),
      key: "UNARCHIVE",
      isVisible: isArchived /** show unarchive cycle option for archived cycles and vice versa */,
      icon: <ArchiveOutlined />,
    },
    {
      label: t("common:archive"),
      key: "ARCHIVE",
      isVisible: !isArchived,
      icon: <ArchiveOutlined />,
    },
    {
      label: t("common:delete"),
      key: "DELETE",
      isVisible: true,
      isDestructive: true,
      icon: <DeleteOutlined />,
    },
  ];

  const filteredOptions = _.filter(allOptions, { isVisible: true });

  return filteredOptions;
};

export const getCycleCardDropdownOptionsMemoized = _.memoize(
  getCycleCardDropdownOptions,
  ({ isTitleEmpty, isArchived }) => {
    return JSON.stringify({
      isTitleEmpty,
      isArchived,
    });
  }
);

export const CYCLE_TYPE_LOCALE_MAPPING = {
  AUTHORIZATION: "snp:authorization",
  EVALUATION: "common:evaluation",
};
